import React, { useEffect, useState, useCallback, Suspense, useMemo, useContext } from "react";
import { getRegularAttandance, updateRegularization } from "./Services/AttendanceService";
import { Paginator } from "primereact/paginator";
import { ogToast, ogOpenModal, ogCloseModal } from "../../../utils/uiHelpers";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { Link } from "react-router-dom";
import {
  addRegularAttandance,
  updateRegularAttendance,
} from "./Services/AttendanceService";
import { useFormik } from "formik";
import * as Yup from "yup";
import { TostMsg } from "../../../App";

const ComponentLoader = React.lazy(
  () => import("../../../Shared/Sidebar/ComponentLoader"),
);

function RegularisationList() {
  const [Isloading, setIsloading] = useState(false);
  const [attendanceStatusType, setAttendanceStatusType] = useState([]);
  const [attendanceReasonType, setAttendanceReasonType] = useState([]);
  const [regularAttendanceList, setRegularAttendanceList] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [editTargetId, setEditTargetId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMine, setIsMine] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [actionType, setActionType] = useState("");
  const [remark, setRemark] = useState("");
  let toaster = useContext(TostMsg);


  useEffect(() => {
    getMasterData();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      const page = first / rows + 1;
      getRegularAttendanceList(page, rows);
    }, 500);

    return () => clearTimeout(delay);
  }, [first, rows, searchValue, selectedStatus]);

  // useEffect(() => {
  //   const page = first / rows + 1;
  //   getRegularAttendanceList(page, rows);
  // }, [first, rows, searchValP:ue, selectedStatus]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const getMasterData = async () => {
    try {
      const statusParams = {
        masterType: "RegularisationStatus",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };
      const typeParams = {
        masterType: "AttendanceStatus",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const [statusRes, typeRes] = await Promise.all([
        GetMasterTypeData(statusParams),
        GetMasterTypeData(typeParams),
      ]);

      setAttendanceStatusType(statusRes?.Data || []);
      setAttendanceReasonType(typeRes?.Data || []);
    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  };

  async function getRegularAttendanceList(page = 1, size = rows) {
    setLoading(true);

    const params = {
      Status: selectedStatus ? Number(selectedStatus) : 0,
      PageNumber: page,
      PageSize: size,
      Search: searchValue,
    };

    try {
      const response = await getRegularAttandance(params);
      setLoading(false);

      const data = response?.Data || [];

      setRegularAttendanceList(data);
      setTotalRecords(data?.[0]?.TotalRecords || 0);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const validationSchema = Yup.object({
    date: Yup.string().required("Date is required"),
    // checkIn: Yup.string().required("Check-in time is required"),
    // checkOut: Yup.string().required("Check-out time is required"),
    reason: Yup.string().required("Reason is required"),
    status: Yup.string().required("Status is required"),
    // details: Yup.string(),
  });

  const regularisationsForm = useFormik({
    initialValues: {
      date: "",
      reason: "",
      status: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      const toISO = (date, time) => {
        if (!date || !time) return null;
        const [hours, minutes] = time.split(":");
        const d = new Date(date);
        d.setHours(hours);
        d.setMinutes(minutes);
        d.setSeconds(0);
        return d.toISOString();
      };

      const payload = {
        Id: editTargetId || 0,
        AttendanceDate: values.date,
        Reason: values.reason,
        RequestedStatusId: Number(values.status),
      };

      try {
        await addRegularAttandance(payload);
        ogToast(
          editTargetId ? "Updated successfully" : "Submitted successfully",
        );
        ogCloseModal("regulariseModal");
        regularisationsForm.resetForm();
        setEditTargetId(null);
        const page = first / rows + 1;
        getRegularAttendanceList(page, rows);
      } catch (err) {
        ogToast("Error submitting request");
      }
      finally {
        setLoading(false);
      }
    },
  });

  const openRegularisationModel = useCallback(
    (editData) => {
      setEditTargetId(editData?.Id || null);
      if (editData) {
        const formatDate = (date) =>
          date ? new Date(date).toISOString().split("T")[0] : "";
        const formatTime = (dateTime) =>
          dateTime ? dateTime.split(" ")[1]?.slice(0, 5) : "";

        regularisationsForm.setValues({
          date: formatDate(editData.AttendanceDate),
          checkIn: formatTime(
            editData.RequestedCheckIn || editData.OriginalCheckIn,
          ),
          checkOut: formatTime(
            editData.RequestedCheckOut || editData.OriginalCheckOut,
          ),
          reason: editData.Reason || "",
          status: editData.RequestedStatusId || "",
          details: editData.AdditionalDetails || "",
        });
      } else {
        regularisationsForm.resetForm();
      }
      ogOpenModal("regulariseModal");
    },
    [regularisationsForm],
  );

  const filteredList = useMemo(() => {
    if (!isMine) return regularAttendanceList;

    return regularAttendanceList.filter((item) => item.IsMine === 1);
  }, [regularAttendanceList, isMine]);


  const formatISTDate = (date) => {
    if (!date) return "";

    // handle default SQL date
    if (date === "1900-01-01 05:30:00") return "";

    const d = new Date(date);

    // optional: extra safety check
    if (d.getFullYear() === 1900) return "";

    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(d);
  };


  const handleUpdateAction = async () => {
    if (!selectedItem) return;

    setLoading(true);

    try {
      let statusId = 0;
      if (actionType === "approve") statusId = 102;
      if (actionType === "decline") statusId = 104;
      if (actionType === "withdraw") statusId = 103;

      const params = {
        Id: selectedItem.Id,
        Remarks: remark?.trim(),
        RegularizationStatusId: statusId,
      };

      await updateRegularization(params);

      ogToast(`${actionType} successful`);

      ogCloseModal("approveModal");
      setSelectedItem(null);
      setActionType("");
      setRemark(""); // reset

      const page = first / rows + 1;
      getRegularAttendanceList(page, rows);

    } catch (error) {
      console.error(error);
      ogToast("Something went wrong");
    } finally {
      setLoading(false);
    }
  };



  return (
    <div>
      <div className="container-fluid">
        <div className="page-head">
          <div>
            <h2>Regularization List</h2>
          </div>
          <div className="head-actions">
            <button
              className="btn-og theme-color btn-og-sm"
              onClick={() => openRegularisationModel(null)}
            >
              <i className="fa fa-plus"></i>New Request
            </button>
            <Link to="/My-Attendance">
              <button
                className="btn-og btn-og-secondary btn-og-sm"
                style={{ justifyContent: "flex-start" }}
              >
                Back
              </button>
            </Link>
          </div>
        </div>

        <div className="og-card">
          <div className="og-card-header p-0">
            <div className="toolbar w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Search request.."
                value={searchValue}
                style={{ width: "200px" }}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  setFirst(0);
                }}
              />
              <div className="toolbar-sep"></div>
              <select
                className="form-select"
                style={{ width: "130px" }}
                value={selectedStatus}
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                  setFirst(0); // reset pagination
                }}
              >
                <option value="">All Status</option>
                {attendanceStatusType.map((status, index) => (
                  <option key={index} value={status.Id}>
                    {status.Name}
                  </option>
                ))}
              </select>

              <div className="toolbar-sep"></div>

              <div className="toolbar-sep"></div>
              <div
                className={`filter-chip ${isMine ? "active" : ""}`}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <input
                  type="checkbox"
                  checked={isMine}
                  onChange={() => setIsMine(!isMine)}
                  onClick={(e) => e.stopPropagation()}
                />
                My requests only
              </div>

              <div className="toolbar-spacer"></div>
              <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>
                {filteredList.length}{" "}
                {filteredList.length === 1 ? "Record" : "Records"}
              </span>
            </div>
          </div>

          <div className="og-card-body p-0">
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                position: "relative",
                width: "100%",
                WebkitOverflowScrolling: "touch",
              }}
            >
              <table
                className="mgmt-tbl regularisation-table"
                style={{
                  borderCollapse: "separate",
                  borderSpacing: 0,
                  minWidth: "100%",
                }}
              >
                <thead>
                  <tr>
                    <th>Employee Name</th>
                    <th>Date</th>

                    <th>Requested Status</th>

                    <th>Reason</th>
                    <th>Status</th>
                    <th>Response Date </th>

                    <th>Remarks</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList && filteredList.length > 0 ? (
                    filteredList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td
                            style={{
                              position: "sticky",
                              left: 0,
                              background: "#fff",
                              zIndex: 1,
                            }}
                          >
                            <span className="desig-cell">
                              {item.EmployeeFirstName} {item.EmployeeLastName}
                            </span>
                          </td>
                          <td
                            style={{
                              position: "sticky",
                              left: 0,
                              background: "#fff",
                              zIndex: 1,
                            }}
                          >
                            {formatISTDate(item.AttendanceDate)}
                          </td>
                          <td
                            style={{
                              position: "sticky",
                              left: 0,
                              background: "#fff",
                              zIndex: 1,
                            }}
                          >
                            <b>{item.RequestedStatus}</b>
                          </td>

                          <td
                            style={{
                              position: "sticky",
                              left: 0,
                              background: "#fff",
                              zIndex: 1,
                            }}
                          >
                            <span className="desig-cell">{item.Reason}</span>
                          </td>
                          <td
                            style={{
                              position: "sticky",
                              left: 0,
                              background: "#fff",
                              zIndex: 1,
                            }}
                          >
                            <span className="att-badge att-P badge">
                              {item.RegularizationStatus}
                            </span>
                          </td>
                          <td
                            style={{
                              position: "sticky",
                              left: 0,
                              background: "#fff",
                              zIndex: 1,
                            }}
                          >
                            {item.ReviewedDate === "1900-01-01 05:30:00"
                              ? "-"
                              : formatISTDate(item.ReviewedDate)}
                          </td>
                          <td
                            style={{
                              position: "sticky",
                              left: 0,
                              background: "#fff",
                              zIndex: 1,
                            }}
                          >
                            <span className="desig-cell">{item.Remarks || "-"}</span>
                          </td>
                          <td style={{
                            position: "sticky",
                            left: 0,
                            background: "#fff",
                            zIndex: 1,
                          }}>
                            {/* <button
                              type="button"
                              className="btn-og btn-og-outline btn-og-xs"
                              onClick={() => openRegularisationModel(item)}
                            >
                              <i className="fa fa-pencil"></i>
                            </button> */}

                            <div
                              className="act-group"
                            // style={{ justifyContent: "flex-end" }}
                            >
                              {/* Case 1: My request → show Withdraw */}


                              {/* Case 2: Not my request → show Approve & Decline */}
                              {item.RegularizationStatusId == 101 &&
                                item.IsMine == 0 && (
                                  <>
                                    <button
                                      className="btn-og btn-approve btn-xs"
                                      onClick={() => {
                                        setSelectedItem(item);
                                        setActionType("approve");
                                        ogOpenModal("approveModal");
                                      }}
                                    >
                                      <i className="fa fa-check"></i> Approve
                                    </button>

                                    <button
                                      className="btn-og btn-decline btn-xs"
                                      onClick={() => {
                                        setSelectedItem(item);
                                        setActionType("decline");
                                        ogOpenModal("approveModal");
                                      }}
                                    >
                                      <i className="fa fa-times"></i> Decline
                                    </button>

                                  </>
                                )}

                              {item.RegularizationStatusId == 101 && item.IsMine == 1 && (
                                <button
                                  className="btn-og btn-secondary btn-xs"
                                  onClick={() => {
                                    setSelectedItem(item);
                                    setActionType("withdraw");
                                    ogOpenModal("approveModal");
                                  }}
                                >
                                  <i className="fa fa-undo"></i> Withdraw
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center" }}>
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="sticky-footer" style={{ position: "relative" }}>
              <div className="og-pagination">
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={totalRecords}
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  onPageChange={onPageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ==================== REGULARISATION MODAL ==================== */}
      <div className="og-modal-overlay" id="regulariseModal">
        <form onSubmit={regularisationsForm.handleSubmit}>
          <div className="og-modal">
            <div className="og-modal-header">
              <h5>
                {/* {editTargetId
                  ? "Edit Attendance Regularisation"
                  : "Add Attendance Regularisation"} */}
                Request Regularisation
              </h5>
              <button
                type="button"
                className="modal-close"
                onClick={() => {
                  ogCloseModal("regulariseModal");
                  regularisationsForm.resetForm();
                  setEditTargetId(null);
                }}
              >
                <i className="fa fa-times"></i>
              </button>
            </div>

            <div className="og-modal-body">
              <div
                style={{
                  background: "#fff8f0",
                  border: "1px solid #fcd9c5",
                  borderRadius: "8px",
                  padding: ".65rem .85rem",
                  marginBottom: "1rem",
                  fontSize: ".77rem",
                  color: "#c94a00",
                }}
              >
                <i
                  className="fa fa-info-circle"
                  style={{ marginRight: ".35rem" }}
                ></i>
                Regularisation requests are reviewed by your manager. You can
                submit up to <strong>3 requests per month</strong>.
              </div>

              <div className="form-group">
                <label className="og-label">
                  Date <span className="req">*</span>
                </label>
                <input
                  type="date"
                  name="date"
                  className={`og-input ${regularisationsForm.errors.date && regularisationsForm.touched.date ? "is-invalid" : ""}`}
                  value={regularisationsForm.values.date}
                  onChange={regularisationsForm.handleChange}
                />
                <div className="invalid-feedback">
                  {regularisationsForm.touched.date &&
                    regularisationsForm.errors.date}
                </div>
              </div>

              {/* <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div className="form-group">
                  <label className="og-label">Actual Check-In <span className="req">*</span></label>
                  <input
                    type="time"
                    name="checkIn"
                    className={`og-input ${regularisationsForm.errors.checkIn && regularisationsForm.touched.checkIn ? "is-invalid" : ""}`}
                    value={regularisationsForm.values.checkIn}
                    onChange={regularisationsForm.handleChange}
                  />
                  <div className="invalid-feedback">
                    {regularisationsForm.touched.checkIn && regularisationsForm.errors.checkIn}
                  </div>
                </div>
 
                <div className="form-group">
                  <label className="og-label">Actual Check-Out <span className="req">*</span></label>
                  <input
                    type="time"
                    name="checkOut"
                    className={`og-input ${regularisationsForm.errors.checkOut && regularisationsForm.touched.checkOut ? "is-invalid" : ""}`}
                    value={regularisationsForm.values.checkOut}
                    onChange={regularisationsForm.handleChange}
                  />
                  <div className="invalid-feedback">
                    {regularisationsForm.touched.checkOut && regularisationsForm.errors.checkOut}
                  </div>
                </div>
              </div> */}

              <div className="form-group">
                <label className="og-label">
                  Status <span className="req">*</span>
                </label>
                <select
                  name="status"
                  className={`form-select ${regularisationsForm.errors.status && regularisationsForm.touched.status ? "is-invalid" : ""}`}
                  value={regularisationsForm.values.status}
                  onChange={regularisationsForm.handleChange}
                >
                  <option value="">— Select Status —</option>
                  {attendanceReasonType.map((status, index) => (
                    <option key={index} value={status.Id}>
                      {status.Name}
                    </option>
                  ))}
                </select>
                <div className="invalid-feedback">
                  {regularisationsForm.touched.status &&
                    regularisationsForm.errors.status}
                </div>
              </div>

              <div className="form-group">
                <label className="og-label">
                  Reason <span className="req">*</span>
                </label>

                <textarea
                  name="reason"
                  className={`og-textarea ${regularisationsForm.errors.reason &&
                    regularisationsForm.touched.reason
                    ? "is-invalid"
                    : ""
                    }`}
                  rows="3"
                  placeholder="Enter reason..."
                  value={regularisationsForm.values.reason}
                  onChange={regularisationsForm.handleChange}
                />

                <div className="invalid-feedback">
                  {regularisationsForm.touched.reason &&
                    regularisationsForm.errors.reason}
                </div>
              </div>

              {/* <div className="form-group">
                <label className="og-label">Additional Details</label>
                <textarea
                  name="details"
                  className="og-textarea"
                  rows="3"
                  value={regularisationsForm.values.details}
                  onChange={regularisationsForm.handleChange}
                  placeholder="Provide additional context for your request…"
                />
              </div> */}
            </div>

            <div className="og-modal-footer">
              <button
                type="button"
                className="btn-og btn-og-secondary"
                onClick={() => {
                  ogCloseModal("regulariseModal");
                  regularisationsForm.resetForm();
                  setEditTargetId(null);
                }}
              >
                Cancel
              </button>
              <button type="submit" className="btn-og btn-og-primary">
                Submit Request
              </button>
            </div>
          </div>
        </form>
      </div>

      <div className="og-modal-overlay" id="approveModal">
        <div className="og-modal ">
          <div className="og-modal-header">
            <h5> Regularisation Details
              {/* {actionType === "approve" && "Approve Request Regularisation"}
              {actionType === "decline" && "Decline Request Regularisation"}
              {actionType === "withdraw" && "Withdraw Request Regularisation"} */}
            </h5>
            <button
              type="button"
              className="modal-close"
              onClick={() => ogCloseModal("approveModal")}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>

          <div className="og-modal-body">
            <div className="details-box request-summary">
              <div className="detail-row rs-row">
                <span className="label rs-lbl">Employee</span>
                <span className="value rs-val">
                  {selectedItem?.EmployeeFirstName}{" "}
                  {selectedItem?.EmployeeLastName}
                </span>
              </div>

              <div className="detail-row rs-row">
                <span className="label rs-lbl">Date</span>
                <span className="value rs-val">
                  {formatISTDate(selectedItem?.AttendanceDate)}
                </span>
              </div>

              <div className="detail-row rs-row">
                <span className="label rs-lbl">Requesting</span>
                <span className="value rs-val">
                  {selectedItem?.RequestedStatus}
                </span>
              </div>

              <div className="detail-row rs-row">
                <span className="label rs-lbl">Reason</span>
                <span className="value rs-val">
                  {selectedItem?.Reason}
                </span>
              </div>


            </div>

            <div className="form-group">
              <label className="og-label" id="commentLabel">Remark</label>
              <textarea
                className="og-textarea"
                id="confirmComment"
                placeholder="e.g. Approved. Please ensure attendance is marked correctly going forward."
                rows="3"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              ></textarea>              </div>
          </div>

          <div className="og-modal-footer">
            <button
              className="btn-og btn-og-secondary"
              onClick={() => ogCloseModal("approveModal")}
            >
              Cancel
            </button>

            {actionType === "approve" && (
              <button
                className="btn-og btn-approve"
                onClick={handleUpdateAction}
                disabled={loading}
              >
                Yes, Approve
              </button>
            )}

            {actionType === "decline" && (
              <button
                className="btn-og btn-decline"
                onClick={handleUpdateAction}
              >
                Yes, Decline
              </button>
            )}

            {actionType === "withdraw" && (
              <button
                className="btn-og btn-secondary"
                onClick={handleUpdateAction}
              >
                Yes, Withdraw
              </button>
            )}
          </div>
        </div>
      </div>

      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default RegularisationList;
